/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { RoadLorryClass } from './road-lorry-class';

export interface MainCarriageRoadAttributes {
    'coolingType'?: MainCarriageRoadAttributesCoolingTypeEnum;
    'emissionClass'?: MainCarriageRoadAttributesEmissionClassEnum;
    'emptyRunFactor'?: number;
    'fuelType'?: MainCarriageRoadAttributesFuelTypeEnum;
    'loadFactor'?: number;
    'lorryClass'?: RoadLorryClass;
}

export enum MainCarriageRoadAttributesCoolingTypeEnum {
    Auto = 'Auto',
    CooledBox = 'CooledBox',
    ReeferUnregulated = 'ReeferUnregulated',
    ReeferRegulated = 'ReeferRegulated'
}
export enum MainCarriageRoadAttributesEmissionClassEnum {
    EuEuro1 = 'EuEuro1',
    EuEuro2 = 'EuEuro2',
    EuEuro3 = 'EuEuro3',
    EuEuro4 = 'EuEuro4',
    EuEuro5 = 'EuEuro5',
    EuEuro6 = 'EuEuro6',
    EuEuro6ac = 'EuEuro6ac',
    EuEuro6de = 'EuEuro6de',
    UsMoves1999 = 'UsMoves1999',
    UsMoves2000 = 'UsMoves2000',
    UsMoves2002 = 'UsMoves2002',
    UsMoves2006 = 'UsMoves2006',
    UsMoves2009 = 'UsMoves2009',
    UsMoves2013 = 'UsMoves2013',
    UsMoves2016 = 'UsMoves2016',
    UsMoves2020 = 'UsMoves2020',
    UsMoves2023 = 'UsMoves2023',
    Jp1994 = 'Jp1994',
    Jp1997 = 'Jp1997',
    Jp2003 = 'Jp2003',
    Jp2005 = 'Jp2005',
    Jp2009 = 'Jp2009',
    Jp2016 = 'Jp2016'
}
export enum MainCarriageRoadAttributesFuelTypeEnum {
    Diesel = 'diesel',
    Cng = 'cng',
    Lng = 'lng',
    LngDiesel = 'lng_diesel',
    Bev = 'bev',
    Gasoline = 'gasoline'
}


